//==============================================================================
// Inject Helper
//
// Tool to inject scripts and stylesheets into the HTML header
//==============================================================================

//----------------------------------------------------------
// Inject a script into the HTML header
//----------------------------------------------------------
export function injectScript(url: string): void {
    // Create the element
    const script = document.createElement('script');
    script.src = url;

    // Inject the element
    document.head.appendChild(script);
}

//----------------------------------------------------------
// Inject a sylesheet into the HTML header
//----------------------------------------------------------
export function injectCss(url: string): void {
    // Create the element
    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = url;

    // Inject the element
    document.head.appendChild(css);
}
